import {
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  IconButton,
  Checkbox,
  Button,
} from '@mui/material';

import React, { useEffect, useState } from 'react';

import { AiTwotoneEdit } from 'react-icons/ai';

import moment from 'moment';
import { v4 } from 'uuid';
import { Container } from './PointControlList.styles';
import IPage from '../../../interfaces/IPage';
import { useToastrVanila } from '../../../hooks/util/useToastrVanila';
import ITimeRecord from '../../../interfaces/ITimeRecord';
import { useLocation, useNavigate } from 'react-router-dom';
import PageTitle from '../../../components/page-title/PageTitle';
import { MdOutlineAssignmentReturn } from 'react-icons/md';
import { usePointControlService } from '../../../hooks/services/usePointControlService';

interface PointControlListProps extends IPage {}

const PointControlList = (props: PointControlListProps) => {
  const [timeRecords, setTimeRecords] = useState<ITimeRecord[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = React.useState<string[]>([]);

  const request = usePointControlService();
  const toastr = useToastrVanila();
  const location = useLocation();
  const navigate = useNavigate();

  const resource = location.pathname.split('/');
  const date = resource[2];
  const employeeId = Number(resource[3]);

  moment.locale();

  const generateDayIntervalBetweenDates = async (endDate: string) => {
    const endDay = endDate.slice(8, 10);
    const month = endDate.slice(5, 7);
    const year = endDate.slice(0, 4);

    const list = [];

    for (let i = 1; i <= Number(endDay); i++) {
      list.push({ id: 'i', value: `${year}-${month}-${i < 10 ? '0' : ''}${i}` });
    }

    return list;
  };

  const list = async (date: string, employeeId: number) => {
    setLoading(true);
    const newDate = date.split('%');
    await request
      .listByEmployeeAndDateTimeRecords(newDate[0], newDate[1].slice(2, 42), employeeId)
      .then(async results => {
        const rows: ITimeRecord[] = [];

        const dateLists = generateDayIntervalBetweenDates(newDate[1].slice(2, 42));

        let i = 0;
        (await dateLists).forEach(dateList => {
          let pointsList: string[] = [];
          let status: string = '';
          let statustr: string = '';
          let origin: number = 0;

          results.forEach((result: ITimeRecord) => {
            if (moment(result.date).format('yyyy-MM-DD') === dateList.value) {
              status = result.status ? result.status : '';
              statustr = result.statustr ? result.statustr : '';
              origin = result.origin ? result.origin : 0;
              pointsList.push(moment(result.points).format('HH:mm z'));
            }
          });

          rows[i] = {
            id: dateList.id,
            date: dateList.value,
            points: pointsList,
            status,
            statustr,
            origin,
          };

          i++;
        });

        setTimeRecords(null);
        setTimeRecords(rows);
        setLoading(false);
      })
      .catch(error => {
        toastr.error(error.message);
        setLoading(false);
      });
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const all: string[] = [];

      timeRecords?.forEach(timeRecord => {
        if (timeRecord.date && timeRecord?.points?.length && timeRecord.statustr !== 'APPROVED') {
          all.push(timeRecord?.date);
        }
      });

      setSelected(all);
    } else {
      setSelected([]);
    }
  };

  useEffect(() => {
    list(date, employeeId);
  }, []);

  return (
    <Container>
      <PageTitle title={`ACERTOS DO COLABORADOR`}>
        <Tooltip title="Voltar para listagem" placement="left-start">
          <IconButton onClick={() => window.history.back()} color="inherit">
            <MdOutlineAssignmentReturn />
          </IconButton>
        </Tooltip>
      </PageTitle>
      {selected.length > 0 && (
        <Button
          variant="contained"
          sx={{ marginTop: 3 }}
          onClick={async () => {
            if (selected.length > 0) {
              await request.updateStatusTimeRecord(employeeId, selected, 'APPROVED');
              setSelected([]);
              list(date, employeeId);
            }
          }}
        >
          Aprovar
        </Button>
      )}
      <TableContainer component={Paper} sx={{ marginTop: '20px' }}>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox color="primary" onChange={handleSelectAllClick} />
              </TableCell>
              <TableCell>Dias</TableCell>
              <TableCell>Horário</TableCell>
              <TableCell>Situação</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {timeRecords &&
              timeRecords !== null &&
              timeRecords.map(timeRecord => {
                return (
                  <TableRow key={timeRecord?.date}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        checked={timeRecord.statustr === 'APPROVED' || selected.includes(timeRecord.date ?? '9999')}
                        disabled={timeRecord?.points?.length ? false : true}
                        onChange={e => {
                          if (timeRecord.date !== undefined && timeRecord.statustr !== 'APPROVED') {
                            if (e.target.checked) {
                              setSelected([...selected, timeRecord?.date]);
                            } else {
                              const all: string[] = [];

                              selected?.forEach(row => {
                                if (row !== timeRecord?.date) {
                                  all.push(row);
                                }
                              });

                              setSelected(all);
                            }
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell sx={timeRecord.statustr === 'APPROVED' ? { color: 'gray' } : { color: '#F8FFFF' }}>
                      {moment(timeRecord?.date).format('DD/MM')}
                      <br />
                      {moment(timeRecord?.date).format('dddd')}
                    </TableCell>
                    <TableCell sx={timeRecord.statustr === 'APPROVED' ? { color: 'gray' } : { color: '#F8FFFF' }}>
                      {timeRecord.points &&
                        timeRecord.points.map(point => {
                          return (
                            <div key={v4()}>
                              <label>{point}</label>
                              <br />
                            </div>
                          );
                        })}
                    </TableCell>
                    <TableCell sx={timeRecord.statustr === 'APPROVED' ? { color: 'gray' } : { color: '#F8FFFF' }}>
                      {timeRecord?.status}
                    </TableCell>
                    <TableCell style={{ maxWidth: 80 }}>
                      <Tooltip title="Editar" placement="top">
                        <IconButton
                          onClick={async () => {
                            navigate(`/point-control-form/${timeRecord.date}/${employeeId}`);
                            setLoading(false);
                          }}
                        >
                          <AiTwotoneEdit style={{ fontSize: '15px' }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default PointControlList;
